// Find the reorder row closest to a Y coordinate (works in gaps between rows too).
export function nearestRow(root, y) {
  const rows = (root || document).querySelectorAll("[data-reorder-id]");
  let best = null;
  let bestDist = Infinity;
  for (const row of rows) {
    const r = row.getBoundingClientRect();
    const dist = y < r.top ? r.top - y : y > r.bottom ? y - r.bottom : 0;
    if (dist < bestDist) { best = { row, rect: r }; bestDist = dist; }
    if (dist === 0) break;
  }
  if (!best) return null;
  const { row, rect } = best;
  return {
    id: row.getAttribute("data-reorder-id"),
    pos: y < rect.top + rect.height / 2 ? "above" : "below",
  };
}
